'use strict';

import angular from 'angular';

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:LanguageService
 * @description
 * Service for handling the Language of the interface
 */
const languageServiceModule = angular.module('languageServiceModule', []);

languageServiceModule.service('LanguageService', ['$q', '$translate', function ($q, $translate) {
    const getLangKey = function (lang) {
        switch (parseInt(lang)) {
            case 1:
                return 'pl';
            case 2:
            default:
                return 'en';
        }
    };

    this.changeTo = function (newLang) {
        const defer = $q.defer();

        if (angular.isDefined(newLang)) {
            const lang = getLangKey(newLang);
            $translate.use(lang);
            defer.resolve('Language successfully changed.');
        } else {
            defer.reject('Could not change the language!');
        }

        return defer.promise;
    };
}]);

export default languageServiceModule;